"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var utils_1 = require("utils");
var INDICATOR_STYLES = "flex mx-auto mb-2 rounded-full h-12 w-12";
var STEP_ID_STYLES = "text-white text-xl font-body m-auto";
var STEP_LABEL_STYLES = "font-body text-xs mx-auto";
var getColor = function (_a) {
    var disabled = _a.disabled, active = _a.active;
    if (disabled) {
        return "bg-contentAreaBorder";
    }
    else if (active) {
        return "bg-primary";
    }
    return "bg-secondary";
};
var Step = function (_a) {
    var step = _a.step, label = _a.label, disabled = _a.disabled, active = _a.active;
    return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: "flex flex-col mx-2" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, utils_1.concatStyles)([
                    INDICATOR_STYLES,
                    getColor({ disabled: disabled, active: active }),
                ]) }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: STEP_ID_STYLES }, { children: step }), void 0) }), void 0), (0, jsx_runtime_1.jsx)("p", __assign({ className: STEP_LABEL_STYLES }, { children: label }), void 0)] }), void 0));
};
exports.Step = Step;
